// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2b7K2","row":"ProcedureTreatmentSummary_row__3eZJx"};